import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RaffleMerchantsContent from "modules/RaffleMerchants";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const RaffleMerchantsPage: React.FC = () => {
  setTitle("Merchant");
  return (
    <Auth>
      <Layout>
        <RaffleMerchantsContent />
      </Layout>
    </Auth>
  );
};

export default RaffleMerchantsPage;
